import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      userId
      email
      createdAt
      updatedAt
      active
      type
      fullName
      position
    }
  }
`;

export const GET_BRANCH_USERS = gql`
  query GetBranchUsers($branchId: Float!) {
    branchUsers(branchId: $branchId) {
      userId
      email
      password
      createdAt
      updatedAt
      active
      type
      fullName
      position
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($userId: Float!) {
    deleteUser(userId: $userId)
  }
`;

export const GET_USERS = gql`
  query {
    Users {
      userId
      fullName
      email
      type
      menuAccessRights
    }
  }
`;

export const GET_BRANCHES_BY_USER = gql`
  query GetBranchesByUserId($userId: Float!) {
    findBranchesByUserId(userId: $userId) {
      branchId
      name
      address
      status
    }
  }
`;

export const GET_USER = gql`
  query GetUser($userId: Int!) {
    User(userId: $userId) {
      userId
      active
      type
      fullName
      position
      contractedWeeklyHours
    }
  }
`;

export const GET_AVAILABLE_BRANCHES_FOR_USER = gql`
  query GetAvailableBranchesForUser($userId: Float!) {
    availableBranchesForUser(userId: $userId) {
      branchId
      name
      email
      phoneNumber
    }
  }
`;

export const ADD_USER_TO_BRANCH = gql`
  mutation AddUserToBranch($userId: Int!, $branchId: Int!) {
    addUserToBranch(userId: $userId, branchId: $branchId) {
      userId
      fullName
      branches {
        branchId
        name
      }
    }
  }
`;

export const REMOVE_USER_FROM_BRANCH = gql`
  mutation RemoveUserFromBranch($userId: Int!, $branchId: Int!) {
    removeUserFromBranch(userId: $userId, branchId: $branchId) {
      userId
      fullName
      branches {
        branchId
        name
      }
    }
  }
`;
